import { LoginHubGetPlayerEmailResponse, ErrorResponse } from '../response';

export type LoginHubGetPlayerEmailAction = () => Promise<LoginHubGetPlayerEmailResponse | ErrorResponse>;
